goog.provide('yext.plugins.modelPicker');
goog.provide('yext.plugins.entityPicker');
goog.provide('yext.plugins.locationPicker');
goog.provide('yext.plugins.subscriptionLocationPicker');
goog.provide('yext.plugins.socialLocationPicker');
goog.provide('yext.plugins.listPicker');
goog.provide('yext.plugins.postLocationPicker');
goog.provide('yext.plugins.optionPicker');
goog.provide('yext.plugins.countryPicker');
goog.provide('yext.plugins.assignedLocationPicker');
goog.provide('yext.plugins.competitorLocationPicker');
goog.provide('yext.plugins.degreePicker');
goog.provide('yext.plugins.yextApiErrorPicker');
goog.provide('yext.plugins.timezonePicker');
goog.provide('yext.plugins.nonAjaxPicker');

goog.require('goog.string');

goog.require('yext');
goog.require('yext.consumerfeedback.routes');
goog.require('yext.developerconsole.routes');
/** @suppress {extraRequire} */
goog.require('yext.plugins.ajaxChosen');
goog.require('yext.socialstorm.routes');
goog.require('yext.storm.routesDEPRECATED');


(function($) {
  $.fn.modelPicker = function(model, selectedIds, disable_single_deselect, options, callback) {
    if ($.inArray(model, ['location', 'list', 'resource', 'postLocation',
      'option', 'country', 'entity',
      'locationToSubscribe', 'socialLocation',
      'degrees', 'yextApiError', 'managedSearcher',
      'timezone', 'nonAjaxPicker']) < 0) {
      throw new TypeError('Invalid model picker type.');
    }

    // Convert selectedIds to array for convenience
    if (!selectedIds) {
      selectedIds = [];
    } else if (typeof selectedIds != 'object') {
      selectedIds = [selectedIds];
    }

    return this.each(function() {
      var $select = $(this);
      if (!$select.is('select')) {
        return;
      }

      if (!$select.data('ajax') && $select.children('option').length > 1) { // Non-ajax mode
        if (selectedIds.length > 0) {
          $select.val(selectedIds);
        }

        if (model == 'option') {
          $select.chosen({
            placeholder_text_single: 'Choose an option',
            disable_search_threshold: 10,
            inherit_select_classes: true,
          });
        } else {
          $select.chosen({
            allow_single_deselect: !disable_single_deselect,
            search_contains: true,
          });
        }

        // .chosen-single href is javascript:void(0) which triggers an
        // onBeforeUnload on IE9. Suppress this with a 'return false'
        $select.siblings('.chosen-container').find('.chosen-single').click(function() {
          return false;
        });

        // Need to trigger an update even though we just created a chosen
        $select.trigger('chosen:updated');
      } else { // Ajax mode
        var url;
        if (model == 'location') {
          if (options && options.permissionIds && typeof options.permissionIds !== 'object') {
            options['permissionIds'] = [options.permissionIds];
          }
          url = yext.storm.routesDEPRECATED.LocationSearch.locationsSearchJson(options);
        } else if (model == 'entity') {
          if (options && options.permissionIds && typeof options.permissionIds !== 'object') {
            options['permissionIds'] = [options.permissionIds];
          }
          options = options || {};
          url = yext.storm.routesDEPRECATED.LocationSearch.entitySearchJson(options);
        } else if (model == 'socialLocation') {
          url = yext.socialstorm.routes.Social.locationsSearchJson(options);
        } else if (model == 'locationToSubscribe') {
          if (options && options.permissionIds && typeof options.excludeLocationIds !== 'object') {
            options.excludeLocationIds = [options.excludeLocationIds];
          }
          url = yext.storm.routesDEPRECATED.Subscriptions.subscriptionLocationsSearchJson(options);
        } else if (model == 'list') {
          var searchObject = {};
          if (options.type != null) {
            searchObject['type'] = options.type;
          }
          if (options.localeCode) {
            searchObject['localeCode'] = options.localeCode;
          }
          url = yext.storm.routesDEPRECATED.EnhancedLists.listsSearchJson(searchObject);
        } else if (model == 'resource') {
          url = window.resourcesSearchJson();
        } else if (model == 'postLocation') {
          url = yext.socialstorm.routes.Social.postLocationsSearchJson(options);
        } else if (model == 'option') {
          // Fall through
        } else if (model == 'country') {
          url = '/s/' + yext.businessId + '/listings/countrySearch';
        } else if (model == 'degrees') {
          url = '/s/' + yext.businessId + '/locations/degreeSearch';
        } else if (model == 'yextApiError') {
          url = yext.developerconsole.routes.DeveloperConsole.yextApiErrorSearch();
        } else if (model == 'managedSearcher') {
          url = '/s/' + yext.businessId + '/locations/managedSearcherSearch?filterName=' + options.filterName;
        } else if (model == 'timezone') {
          url = '/s/' + yext.businessId + '/locations/timezoneSearch';
        } else {
          return;
        }

        // Configure ajax chosen
        var chosenOptions = {
          chosenSettings: {
            allow_single_deselect: !disable_single_deselect,
          },
          method: 'GET',
          url: url,
          dataType: 'json',
        };
        if (options && options.minTermLength) {
          chosenOptions.minTermLength = options.minTermLength;
        }
        $select.ajaxChosen(chosenOptions, function(data) {
          var terms = {};
          if (model == 'postLocation') {
            terms[0] = yext.msg('All locations');
          }
          $.each(data, function(i, val) {
            terms[val.id] = goog.string.htmlEscape(val.label);
          });
          return terms;
        });

        // .chosen-single href is javascript:void(0) which triggers an
        // onBeforeUnload on IE9. Suppress this with a 'return false'
        $select.siblings('.chosen-container').find('.chosen-single').click(function() {
          return false;
        });

        // Restore state for picker by searching for and restoring from ids
        if (selectedIds.length > 0) {
          // Potentially create fake <option> so val() calls will work while
          // still restoring state
          $.each(selectedIds, function(i, id) {
            var $option = $select.children('option[value="' + id + '"]');
            if ($option.length === 0) {
              $('<option />').addClass('temp').attr('value', id).appendTo($select);
            }
          });

          // Purposely don't trigger('chosen:updated') so the user doesn't see
          // an empty selection in the chosen
          $select.val(selectedIds);

          // If we are trying to restore an ID in a listpicker, we increase the number of results
          // returned to make sure the ID is actually in the searched list
          if (model == 'list' && options['type']) {
            searchObject['maxResults'] = 1000;
            url = yext.storm.routesDEPRECATED.EnhancedLists.listsSearchJson(searchObject);
          }

          $.getJSON(url, {'ids': selectedIds}, function(data) {
            $select.find('.temp').remove();
            $.each(data, function(i, val) {
              var id = val.id;
              var label = val.label;
              var $option = $select.children('option[value="' + id + '"]');
              if ($option.length === 0) {
                $('<option />').attr('value', id).html(label).appendTo($select);
              }
            });

            $select.val(selectedIds).trigger('chosen:updated');
            if (typeof(callback) == 'function') {
              callback();
            }
          });
        }
      }
    });
  };

  $.fn.locationPicker = function(selectedIds, disable_single_deselect, options, callback) {
    $(this).modelPicker('location', selectedIds, disable_single_deselect, options, callback);
  };

  $.fn.entityPicker = function(selectedIds, disable_single_deselect, options, callback) {
    $(this).modelPicker('entity', selectedIds, disable_single_deselect, options, callback);
  };

  $.fn.subscriptionLocationPicker = function(selectedIds, disable_single_deselect, options, callback) {
    $(this).modelPicker('locationToSubscribe', selectedIds, disable_single_deselect, options, callback);
  };

  $.fn.socialLocationPicker = function(selectedIds) {
    $(this).modelPicker('socialLocation', selectedIds, null, null, null);
  };

  $.fn.listPicker = function(selectedIds, disable_single_deselect, type, localeCode) {
    $(this).modelPicker('list', selectedIds, disable_single_deselect, {type: type, localeCode: localeCode});
  };

  $.fn.postLocationPicker = function(selectedIds, disable_single_deselect, options) {
    $(this).modelPicker('postLocation', selectedIds, disable_single_deselect, options);
  };

  $.fn.optionPicker = function(selectedIds, disable_single_deselect, choices) {
    $(this).modelPicker('option', selectedIds, disable_single_deselect, choices);
  };

  $.fn.countryPicker = function(selectedIds) {
    $(this).modelPicker('country', selectedIds);
  };

  $.fn.degreePicker = function(selectedIds) {
    $(this).modelPicker('degrees', selectedIds);
  };

  $.fn.assignedLocationPicker = function(selectedIds, disable_single_deselect, options, callback) {
    $(this).modelPicker('assignedLocation', selectedIds, disable_single_deselect, options, callback);
  };

  $.fn.competitorLocationPicker = function(selectedIds, disable_single_deselect, options, callback) {
    $(this).modelPicker('competitorLocation', selectedIds, disable_single_deselect, options, callback);
  };

  $.fn.yextApiErrorPicker = function(selectedIds, disable_single_deselect, options, callback) {
    $(this).modelPicker('yextApiError', selectedIds, disable_single_deselect, {minTermLength: 1}, callback);
  };

  $.fn.managedSearcherPicker = function(selectedIds, disable_single_deselect, options, callback) {
    $(this).modelPicker('managedSearcher', selectedIds, disable_single_deselect, options, callback);
  };

  $.fn.timezonePicker = function(selectedIds) {
    $(this).modelPicker('timezone', selectedIds);
  };

  $.fn.nonAjaxPicker = function(selectedIds, disable_single_deselect, options) {
    $(this).modelPicker('nonAjaxPicker', selectedIds, disable_single_deselect, options);
  };
})(jQuery);
